import { getToken } from "../auth";

export const setTokenFunc = {
   
   created() {
   
      this.$store.dispatch('FETCH_FILTERS')
      .then(()=>{
         if(this.$store.state.envServer.pis) {
            document.body.oncontextmenu = () => { return false; }
            document.body.ondragstart = () => { return false; }
            document.body.onselectstart = () => { return false; }
          }
      });

      //app check 
      this.checkApp();
      //ip and host get
      this.checkDev();
      
      this.setVtgParmeter();
      
      //token set 개발 || web || app일 경우 plus_id 없으면 안된다. 
      if( this.$store.state.isDev ||  // 개발
         !this.$store.state.isApp ||  // web
         (this.$store.state.isApp && typeof this.$route.query.vtg_id != 'undefined') //app and plus_id isset
      ){
         getToken(this.$route.query.vtg_id, this.getPkgs);
      }
         

   },

   methods: {
      setVtgParmeter() {
         const vtg_id = this.$route.query.vtg_id;
         const preUrl = this.$route.query.preUrl;
         const selOpt = this.$route.query.selOpt;               // 선택 상품     ex) 4,7,9
         const campaignNo = this.$route.query.campaignNo;       // 캠페인 idx
         const brdCampaignNo = this.$route.query.brdCampaignNo; // 캠페인 화면 number
         const vehicleIdx = this.$route.query.vehicleIdx;       // 차량 idx
         const scpNo = this.$route.query.scpNo;                 // SCP 패키지 idx
         const brdScpNo = this.$route.query.brdScpNo;           // SCP 패키지 idx
   
         if(vtg_id) this.$store.state.vtg_id = vtg_id;
         if(preUrl) this.$store.state.preUrl = preUrl;
         if(selOpt) this.$store.state.selOpt = selOpt;
         if(campaignNo) this.$store.state.campaignNo = campaignNo;
         if(brdCampaignNo) this.$store.state.brdCampaignNo = brdCampaignNo;
         if(vehicleIdx) this.$store.state.vehicleIdx = vehicleIdx;
         if(scpNo) this.$store.state.scpNo = scpNo;
         if(brdScpNo) this.$store.state.brdScpNo = brdScpNo;
      }
   },
   
};